import { getMatterArtifactDraftsByMatterId } from '@/matter-artifacts/fetch/get-matter-artifact-drafts-by-matter-id'
import type { MatterArtifactVersionRead } from '@/matter-artifacts/schemas'

/**
 * A draft's current version, read from the server rather than taken from its list row.
 *
 * A row carries the version id the list last fetched, and nothing tells this tab when another
 * member of the matter saves an edit, so that id can already name a superseded version. Every other
 * route into a draft re-reads the head first — opening a row loads the conversation, and the draft
 * view's export flushes the editor and re-reads — which leaves the row menu as the one export that
 * could hand over an out-of-date document.
 *
 * The response is read and discarded rather than written back into the list: the list's own refresh
 * owns that state, including what to do about an invalidation that lands mid-fetch, and an export
 * writing into it would race that.
 *
 * Null when the draft is no longer among the matter's drafts, which means another member has deleted
 * it since the list was fetched. That is an answer, not a failure, so it comes back as a value for
 * the caller to act on rather than as a rejection.
 */
export async function getCurrentDraftVersion(matterId: string, matterArtifactId: string): Promise<MatterArtifactVersionRead | null> {
  const drafts = await getMatterArtifactDraftsByMatterId(matterId)
  return drafts.find((entry) => entry.artifact_version.matter_artifact_id === matterArtifactId)?.artifact_version ?? null
}
